import { createFileRoute, notFound } from "@tanstack/react-router";

import { devicesQueries } from "@/api/resources/devices/queries";
import { partsQueries } from "@/api/resources/parts/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import DevicePartPage from "@/components/DevicePart/DevicePartPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/devices/$device_id/parts/$part_id/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.devices"),
        icon: <Icon.DEVICES />,
        path: "/workspaces/$workspace_id/devices",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, device_id, part_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentDevice = await context.queryClient.ensureQueryData(devicesQueries.byId(device_id));
    if (!currentDevice) throw notFound();
    const currentPart = await context.queryClient.ensureQueryData(partsQueries.byId(part_id));
    if (!currentPart) throw notFound();

    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: currentDevice.name,
        icon: <Icon.DEVICE />,
        path: "/workspaces/$workspace_id/devices/$device_id",
      },
      {
        label: currentPart.part_model.name,
        icon: <Icon.PART />,
      },
    ];
    context.breadcrumbs.splice(2, 2, ...breadcrumbs);
  },
  component: DevicePartPage,
});
